/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    SimpleShowLayout,
    Datagrid,
    ReferenceField,
    ReferenceInput,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { Typography, Box } from '@mui/material';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import {
    AutocompleteInput,
    BooleanInput,
    DateInput,
    RichTextInput,
    TextInput,
} from '../lib/wrappers/Inputs';

export const ExternalExaminerLabels = {
    pageTitle: 'External Examiners',
    singleLabel: 'ExternalExaminer',
};

export const ExternalExaminerList = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={ExternalExaminerLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    {/*<TextField source="id" />
                    <TextField source="veroId" /> */}
                    <TextField source="firstName" title="First Name" />
                    <TextField source="surname" title="Surname" />
                    <TextField source="welsh" title="Welsh" />
                    <TextField source="notes" title="Notes" />
                    <TextField source="tenureStart" title="Tenure Start" />
                    <TextField source="tenureEnd" title="Tenure End" />
                    <TextField
                        source="quercusPlusPersonIDNumber"
                        title="Quercus Plus Person ID Number"
                    />
                </Datagrid>
            </SwList>{' '}
        </ReadOnlyContext.Provider>
    );
};

export const ExternalExaminerEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <Typography variant="h6" gutterBottom>
                        General
                    </Typography>
                    <Box display="flex" width={1}>
                        <Box flex={2}>
                            <TextInput
                                source="firstName"
                                label="First Name"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="surname"
                                label="Surname"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput source="title" label="Title" fullWidth />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="gender"
                                label="Gender"
                                fullWidth
                            />
                        </Box>
                    </Box>
                    <Box display="flex" width={1}>
                        <Box flex={2}>
                            <TextInput
                                source="uswEmail"
                                label="USW Email Address"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput source="code" label="Code" fullWidth />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="quercusPlusPersonIDNumber"
                                label="Quercus ID Number"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="blackboardUserName"
                                label="Blackboard Username"
                                fullWidth
                            />
                        </Box>
                    </Box>
                    <Box display="flex" width={1}>
                        <Box flex={3}>
                            <AutocompleteInput
                                source="isActive"
                                label="Active"
                                fullWidth
                                choices={[
                                    { id: 'active', name: 'Active' },
                                    { id: 'not-active', name: 'Not Active' },
                                ]}
                            />
                        </Box>
                        <Box flex={3} ml="0.5em">
                            <DateInput
                                source="tenureStart"
                                label="Tenure Start"
                                fullWidth
                            />
                        </Box>
                        <Box flex={3} ml="0.5em">
                            <DateInput
                                source="tenureEnd"
                                label="Tenure End"
                                fullWidth
                            />
                        </Box>
                        <Box flex={3} ml="0.5em">
                            <BooleanInput
                                source="welsh"
                                label="Welsh"
                                fullWidth
                            />
                        </Box>
                    </Box>
                    <Box display="flex" width={1}>
                        <Box flex={1}>
                            <ReferenceInput
                                reference="PartnerCollege"
                                source="partnerCollegeId"
                                linkType="edit"
                                label="Partner College"
                            >
                                <AutocompleteInput
                                    optionText="Title"
                                    label="Partner College"
                                    fullWidth
                                />
                            </ReferenceInput>
                        </Box>
                        <Box flex={3} ml="0.5em">
                            <RichTextInput
                                source="notes"
                                label="Notes"
                                fullWidth
                            />
                        </Box>
                    </Box>
                    <Typography variant="h6" gutterBottom>
                        Home Contact Info
                    </Typography>
                    <Box display="flex" width={1}>
                        <Box flex={2}>
                            <TextInput
                                source="homeAddress1"
                                label="Home Address Line 1"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="homeAddress2"
                                label="Home Address Line 2"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="homeAddress3"
                                label="Home Address Line 3"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="homeAddress4"
                                label="Home Address Line 4"
                                fullWidth
                            />
                        </Box>
                    </Box>

                    <Box display="flex" width={1}>
                        <Box flex={2}>
                            <TextInput
                                source="homePostCode"
                                label="Home Post Code"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="homePhone"
                                label="Home Phone"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="homeEmail"
                                label="Home Email"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em"></Box>
                    </Box>

                    <Typography variant="h6" gutterBottom>
                        Work Contact Info
                    </Typography>
                    <Box display="flex" width={1}>
                        <Box flex={2}>
                            <TextInput
                                source="workAddress1"
                                label="Work Address Line 1"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="workAddress2"
                                label="Work Address Line 2"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="workAddress3"
                                label="Work Address Line 3"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="workAddress4"
                                label="Work Address Line 4"
                                fullWidth
                            />
                        </Box>
                    </Box>

                    <Box display="flex" width={1}>
                        <Box flex={2}>
                            <TextInput
                                source="workPostCode"
                                label="Work Post Code"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="workPhone"
                                label="Work Phone"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="workEmail"
                                label="Work Email"
                                fullWidth
                            />
                        </Box>
                        <Box flex={2} ml="0.5em"></Box>
                    </Box>
                    <Box display="flex" width={1}>
                        <Box flex={2}>
                            <TextInput
                                source="updated_at"
                                label="Last Updated"
                                fullWidth
                                disabled
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="created_at"
                                label="Created"
                                fullWidth
                                disabled
                            />
                        </Box>
                        <Box flex={2} ml="0.5em">
                            <TextInput
                                source="lastUpdatedBy"
                                label="Last Updated By"
                                fullWidth
                                disabled
                            />
                        </Box>
                    </Box>
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const ExternalExaminerCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <Typography variant="h6" gutterBottom>
                General
            </Typography>
            <Box display="flex" width={1}>
                <Box flex={2}>
                    <TextInput
                        source="firstName"
                        label="First Name"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput source="surname" label="Surname" fullWidth />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput source="title" label="Title" fullWidth />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput source="gender" label="Gender" fullWidth />
                </Box>
            </Box>
            <Box display="flex" width={1}>
                <Box flex={2}>
                    <TextInput
                        source="uswEmail"
                        label="USW Email Address"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput source="code" label="Code" fullWidth />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="quercusPlusPersonIDNumber"
                        label="Quercus ID Number"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="blackboardUserName"
                        label="Blackboard Username"
                        fullWidth
                    />
                </Box>
            </Box>
            <Box display="flex" width={1}>
                <Box flex={3}>
                    <AutocompleteInput
                        source="isActive"
                        label="Active"
                        fullWidth
                        choices={[
                            { id: 'active', name: 'Active' },
                            { id: 'not-active', name: 'Not Active' },
                        ]}
                    />
                </Box>
                <Box flex={3} ml="0.5em">
                    <DateInput
                        source="tenureStart"
                        label="Tenure Start"
                        fullWidth
                    />
                </Box>
                <Box flex={3} ml="0.5em">
                    <DateInput
                        source="tenureEnd"
                        label="Tenure End"
                        fullWidth
                    />
                </Box>
                <Box flex={3} ml="0.5em">
                    <BooleanInput source="welsh" label="Welsh" fullWidth />
                </Box>
            </Box>
            <Box display="flex" width={1}>
                <Box flex={1}>
                    <ReferenceInput
                        reference="PartnerCollege"
                        source="partnerCollegeId"
                        linkType="edit"
                        label="Partner College"
                    >
                        <AutocompleteInput
                            optionText="description"
                            label="Partner College"
                            fullWidth
                        />
                    </ReferenceInput>
                </Box>
                <Box flex={3} ml="0.5em">
                    <RichTextInput source="notes" label="Notes" fullWidth />
                </Box>
            </Box>
            <Typography variant="h6" gutterBottom>
                Home Contact Info
            </Typography>
            <Box display="flex" width={1}>
                <Box flex={2}>
                    <TextInput
                        source="homeAddress1"
                        label="Home Address Line 1"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="homeAddress2"
                        label="Home Address Line 2"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="homeAddress3"
                        label="Home Address Line 3"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="homeAddress4"
                        label="Home Address Line 4"
                        fullWidth
                    />
                </Box>
            </Box>

            <Box display="flex" width={1}>
                <Box flex={2}>
                    <TextInput
                        source="homePostCode"
                        label="Home Post Code"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="homePhone"
                        label="Home Phone"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="homeEmail"
                        label="Home Email"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em"></Box>
            </Box>

            <Typography variant="h6" gutterBottom>
                Work Contact Info
            </Typography>
            <Box display="flex" width={1}>
                <Box flex={2}>
                    <TextInput
                        source="workAddress1"
                        label="Work Address Line 1"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="workAddress2"
                        label="Work Address Line 2"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="workAddress3"
                        label="Work Address Line 3"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="workAddress4"
                        label="Work Address Line 4"
                        fullWidth
                    />
                </Box>
            </Box>

            <Box display="flex" width={1}>
                <Box flex={2}>
                    <TextInput
                        source="workPostCode"
                        label="Work Post Code"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="workPhone"
                        label="Work Phone"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="workEmail"
                        label="Work Email"
                        fullWidth
                    />
                </Box>
                <Box flex={2} ml="0.5em"></Box>
            </Box>
            <Box display="flex" width={1}>
                <Box flex={2}>
                    <TextInput
                        source="updated_at"
                        label="Last Updated"
                        fullWidth
                        disabled
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="created_at"
                        label="Created"
                        fullWidth
                        disabled
                    />
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput
                        source="lastUpdatedBy"
                        label="Last Updated By"
                        fullWidth
                        disabled
                    />
                </Box>
            </Box>
        </SimpleForm>
    </Create>
);

export const ExternalExaminerShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <div className="form">
                <div className="row">
                    <div className="thirdblock">
                        <h3>General Details</h3>
                        <div className="content">
                            <label>Title</label>
                            <TextField source="title" title="title" />
                        </div>
                        <div className="content">
                            <label>Name</label>
                            <TextField source="firstName" title="First Name" />
                        </div>
                        <div className="content">
                            <label>Surname</label>
                            <TextField source="surname" title="Surname" />
                        </div>

                        <div className="content">
                            <label>Gender</label>
                            <TextField source="gender" title="Gender" />
                        </div>
                        <div className="content">
                            <label>Tenure Start</label>
                            <TextField
                                source="tenureStart"
                                title="Tenure Start"
                            />
                        </div>
                        <div className="content">
                            <label>Tenure End</label>
                            <TextField source="tenureEnd" title="Tenure End" />
                        </div>
                        <div className="content">
                            <label>Quercus Plus Person ID Number</label>
                            <TextField
                                source="quercusPlusPersonIDNumber"
                                title="Quercus Plus Person ID Number"
                            />
                        </div>
                        <div className="content">
                            <label>Blackboard Username</label>
                            <TextField
                                source="blackboardUserName"
                                title="Blackboard Username"
                            />
                        </div>
                        <div className="content">
                            <label>USW Email Address</label>
                            <TextField
                                source="uswEmail"
                                title="USW Email Address"
                            />
                        </div>
                        <div className="content">
                            <label>Code</label>
                            <TextField source="code" title="Code" />
                        </div>
                        <div className="content">
                            <label>Welsh</label>
                            <BooleanField source="welsh" title="Welsh" />
                        </div>
                        <div className="content">
                            <label>Active</label>
                            <TextField source="isActive" title="Active" />
                        </div>
                    </div>
                    <div className="thirdblock">
                        <h3>Home Contact Details</h3>
                        <div className="content">
                            <label>Address</label>
                            <TextField
                                source="homeAddress1"
                                title="Home Address Line 1"
                            />
                        </div>
                        <div className="content">
                            <TextField
                                source="homeAddress2"
                                title="Home Address Line 2"
                            />
                        </div>
                        <div className="content">
                            <TextField
                                source="homeAddress3"
                                title="Home Address Line 3"
                            />
                        </div>
                        <div className="content">
                            <TextField
                                source="homeAddress4"
                                title="Home Address Line 4"
                            />
                        </div>
                        <div className="content">
                            <TextField
                                source="homePostCode"
                                title="Home Post Code"
                            />
                        </div>
                        <div className="content">
                            <label>Phone</label>
                            <TextField source="homePhone" title="Home Phone" />
                        </div>
                        <div className="content">
                            <label>Email</label>
                            <TextField source="homeEmail" title="Home Email" />
                        </div>
                    </div>
                    <div className="thirdblock">
                        <h3>Work Contact Details</h3>
                        <div className="content">
                            <label>Address</label>
                            <TextField
                                source="workAddress1"
                                title="Work Address Line 1"
                            />
                        </div>
                        <div className="content">
                            <TextField
                                source="workAddress2"
                                title="Work Address Line 2"
                            />
                        </div>
                        <div className="content">
                            <TextField
                                source="workAddress3"
                                title="Work Address Line 3"
                            />
                        </div>
                        <div className="content">
                            <TextField
                                source="workAddress4"
                                title="Work Address Line 4"
                            />
                        </div>
                        <div className="content">
                            <TextField
                                source="workPostCode"
                                title="Work Post Code"
                            />
                        </div>
                        <div className="content">
                            <label>Phone</label>
                            <TextField source="workPhone" title="Work Phone" />
                        </div>
                        <div className="content">
                            <label>Email</label>
                            <TextField source="workEmail" title="Work Email" />
                        </div>
                        <div className="content">
                            <ReferenceField
                                reference="PartnerCollege"
                                source="partnerCollegeId"
                                label="Partner College"
                            >
                                <TextField
                                    source="description"
                                    label="Partner College"
                                    fullwidth
                                />
                            </ReferenceField>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="fullWidthBlock">
                        <h3>Additional Details</h3>
                        <div className="content">
                            <label>Notes</label>
                            <TextField source="notes" title="Notes" />
                        </div>
                        <div className="content">
                            <label>Created</label>
                            <TextField
                                source="created_at"
                                title="Created"
                                disabled
                            />
                        </div>
                        <div className="content">
                            <label>Updated At</label>
                            <TextField
                                source="updated_at"
                                title="Last Updated"
                                disabled
                            />
                        </div>
                        <div className="content">
                            <label>Last Updated By</label>
                            <TextField
                                source="lastUpdatedBy"
                                title="Last Updated By"
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
        </SimpleShowLayout>
    </Show>
);
